import tools from '../../../../assets/javascript/tools.js'
export default {
	columns: {
		headImgUrl: {
			label: '头像',
			visible: true,
			width: '80',
			align: 'left',
		},
		staffName: {
			label: '店员姓名',
			visible: true,
			width: '80',
			align: 'left',
		},
		jobIdentityCn: {
			label: '店员身份',
			visible: true,
			width: '80',
			align: 'left',
		},
		mobile: {
			label: '手机号码',
			visible: true,
			width: '120',
			align: 'left',
		},
		// positionIdCn:{
		// 	label: '职位',
		//     visible: true,
		//     width: 'auto',
		//     align: "left"
		// },
		staffNo: {
			label: '店员编号',
			visible: true,
			width: '100',
			align: 'left',
		},
		joinTime: {
			label: '入职时间',
			visible: true,
			width: '100',
			formatDay: true,
			align: 'left',
		},
		statusCn: {
			label: '店员状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		accountStatusCn: {
			label: '账号状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		auditStatusCn: {
			label: '入职状态',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		positionName: {
			label: '店员职位',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		roleNames: {
			label: '关联角色',
			visible: true,
			width: 'auto',
			align: 'left',
		}
	},
	disableColumns: {
		headImgUrl: {
			label: '头像',
			visible: true,
			width: '80',
			align: 'left',
		},
		staffName: {
			label: '店员姓名',
			visible: true,
			width: '80',
			align: 'left',
		},
		mobile: {
			label: '手机号码',
			visible: true,
			width: '120',
			align: 'left',
		},
		staffNo: {
			label: '店员工号',
			visible: true,
			width: '100',
			align: 'left',
		},
		statusCn: {
			label: '店员状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		accountStatusCn: {
			label: '账号状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		auditStatusCn: {
			label: '入职状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		jobIdentityCn: {
			label: '店员身份',
			visible: true,
			width: '80',
			align: 'left',
		},

		joinTime: {
			label: '入职时间',
			visible: true,
			width: '100',
			formatDay: true,
			align: 'left',
		},
		disableReasonCn: {
			label: '禁用原因',
			visible: true,
			width: 'auto',
			align: 'left',
		},
	},
	noColumns: { // 第三方
		headImgUrl: {
			label: '头像',
			visible: true,
			width: '80',
			align: 'left',
		},

		staffName: {
			label: '店员姓名',
			visible: true,
			width: '80',
			align: 'left',
		},
		mobile: {
			label: '手机号码',
			visible: true,
			width: '120',
			align: 'left',
		},
		staffNo: {
			label: '店员工号',
			visible: true,
			width: '100',
			align: 'left',
		},
		auditStatusCn: {
			label: '入职状态',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		positionName: {
			label: '店员职位',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		roleNames: {
			label: '关联角色',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		auditRemark: {
			label: '审核备注',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		sourceCn: {
			label: '招聘渠道',
			visible: true,
			width: '80',
			align: 'left',
		},
		technTypeCn: {
			label: '技师类型',
			visible: true,
			width: '80',
			align: 'left',
		},
		guaranteeFlagCn: {
			label: '技师入职补助',
			visible: true,
			width: '80',
			align: 'left',
		},

		jobIdentityCn: {
			label: '店员身份',
			visible: true,
			width: '80',
			align: 'left',
		},
		joinTime: {
			label: '入职时间',
			visible: true,
			width: '100',
			formatDay: true,
			align: 'left',
		},
		statusCn: {
			label: '店员状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		accountStatusCn: {
			label: '账号状态',
			visible: true,
			width: '80',
			align: 'left',
		},
	},
	noDisableColumns: {
		headImgUrl: {
			label: '头像',
			visible: true,
			width: '80',
			align: 'left',
		},
		staffName: {
			label: '店员姓名',
			visible: true,
			width: '80',
			align: 'left',
		},

		mobile: {
			label: '手机号码',
			visible: true,
			width: '120',
			align: 'left',
		},
		staffNo: {
			label: '店员编号',
			visible: true,
			width: '100',
			align: 'left',
		},
		auditStatusCn: {
			label: '入职状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		positionName: {
			label: '店员职位',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		roleNames: {
			label: '关联角色',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		sourceCn: {
			label: '招聘渠道',
			visible: true,
			width: '80',
			align: 'left',
		},
		technTypeCn: {
			label: '技师类型',
			visible: true,
			width: '80',
			align: 'left',
		},
		jobIdentityCn: {
			label: '店员身份',
			visible: true,
			width: '80',
			align: 'left',
		},
		guaranteeFlagCn: {
			label: '技师入职补助',
			visible: true,
			width: '80',
			align: 'left',
		},
		joinTime: {
			label: '入职时间',
			visible: true,
			width: '100',
			formatDay: true,
			align: 'left',
		},

		statusCn: {
			label: '店员状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		accountStatusCn: {
			label: '账号状态',
			visible: true,
			width: '80',
			align: 'left',
		},

		disableReasonCn: {
			label: '禁用原因',
			visible: true,
			width: 'auto',
			align: 'left',
		},
	}
}
